// @flow

import React from 'react';
import { checkDecimals } from '../../../../helpers/checkDecimals';
import StyledRating, { RatingWrapper } from './rating.styled';
import Stars from './atoms/stars';
import type { ReviewTemplate, ReviewView } from '../../types';

type Props = {
  id?: number,
  rating: number,
  template: ReviewTemplate,
  view: ReviewView,
};

const Rating = ({
  id,
  rating,
  template,
  view,
}: Props) => (
  <RatingWrapper view={view}>
    <StyledRating
      template={template}
      view={view}
    >
      {checkDecimals(rating)}
      <span> / 10</span>
    </StyledRating>
    <Stars
      id={id}
      rating={rating}
      view={view}
    />
  </RatingWrapper>
);

Rating.defaultProps = {
  id: 0,
};

export default Rating;
